import React, {useState, useEffect, useRef} from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

import server from 'server/serverController2';
import constants from 'utils/constants'
import { compressImage, removeItem } from 'utils/utils';

import TitleHeader from 'components/presenters/header/TitleHeader';
import CommunityWriteForm from 'components/presenters/community/CommunityWriteForm';
import CenterModal from 'components/presenters/modal/CenterModal';


export default function CommunityPostEdit({postNo, type}) {
    const [writeType, setWriteType] = useState(null)
    const [writeValue, setWriteValue] = useState('');
    const [currImgCapacity, setCurrImgCapacity] = useState(0);
    const [imageList, setImageList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isEnd, setIsEnd] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    //CenterModal
    const [centerModalVisible, setCenterModalVisible] = useState(false);
    const [centerModalDataList, setCenterModalDataList] = useState(null);
    const [onCenterModalComplete, setOnCenterModalComplete] = useState(null);
    const [onCenterModalCancel, setOnCenterModalCancel] = useState(null);
    const [initCenterModalState, setInitCenterModalState] = useState(false);
    
    const history = useHistory();
    const fileInputRef = useRef(null);

    let url = null;
    if(type === 'campaign')
    {
        url = `campaigns/posts/${postNo}`;
    }
    else if(type === 'group')
    {
        url = `groups/posts/${postNo}`;
    }

    const postType = {
        free_topic: '1',
        review: '2',
        greeting: '3',
        info: '4'
    }

    const handleChangeWriteType = (e) => {
        const type = e.currentTarget.getAttribute('data-type');
        setWriteType(type);
    }

    const handleChangeWriteValue = (e) => {
        const value = e.target.value;
        setWriteValue(value);
    }

    const handleChangeImageList = async (e) => {
        const imgMaxCapacity = 10;
        let imgCapacity = currImgCapacity;
        if((currImgCapacity+(e?.target?.files?.length)) > imgMaxCapacity)
        {
            setCenterModalVisible(true);
            setCenterModalDataList({type: 'callback', description: '이미지는 10개까지 가능해요'})
            setOnCenterModalComplete(() => () => setCenterModalVisible(false));
            return;
        }
        const copyImageList = [];
        const value = e.target.files;
        for(let key of Object.keys(value))
        {
            const compressedImg = await compressImage(value[key]);
            copyImageList.push({type: 'newImage', data: compressedImg});
            ++imgCapacity;
        }
        fileInputRef.current.value = null; 
        setCurrImgCapacity(imgCapacity);
        setImageList([...imageList, ...copyImageList]);
    }

    const handleClickDeleteImage = (index) => {
        const copyImageList = Object.assign(imageList);
        const reloadImageList = removeItem(copyImageList, index);
        setCurrImgCapacity(parseInt(reloadImageList.length));
        setImageList(reloadImageList);
    }

    const handleUpdatePostCallback = (res) => {
        try
        {
            if(res['success'] !== 1)
            {
                return;
            }
            setIsSubmitting(false);
            history.goBack();
        }
        catch(error)
        {
            console.log(error);
        }
    }

    const handleFileUploadCallback = async (res) => {
        try 
        {
            if(res['success'] !== 1)
            {
                return;
            }
            let imgPathList = [];
            const uploadItem = res['data']['upload_results'];
            uploadItem.map((item) => {
                imgPathList.push(item['file_name']);
            })
            
            imageList.map((image) => {
                 if(image['type'] === 'bucketImage')
                 {
                    imgPathList = [image['data'], ...imgPathList];
                 }
            })
            const body = {
                category_no: writeType,
                content: writeValue,
                img_attachment: imgPathList
            }

            if(type === 'campaign')
            {
                await server.putRequestData(`campaigns/posts/${postNo}`, JSON.stringify(body), handleUpdatePostCallback)
            }
            else if(type === 'group')
            {
                await server.putRequestData(`groups/posts/${postNo}`, JSON.stringify(body), handleUpdatePostCallback)
            }
        }
        catch(error)
        {
            console.log(error);
        }
    }

    const onSubmitFormData = async () => {
        const formData = new FormData();

        if(type === 'campaign')
        {
            formData.append('path', 'campaign_post_img/');
        }
        else if(type === 'group')
        {
            formData.append('path', 'group_post_img/');
        }

        for(let i = 0; i < imageList.length; ++i)
        {
            if(imageList[i]['type'] === 'newImage')
            {
                formData.append('file', imageList[i]['data']);
            }
        }

        await server.postRequestFormData('file', formData, handleFileUploadCallback)
    }

    const handleSubmit = async () => {
        if([null, undefined].includes(writeType))
        {
            setCenterModalVisible(true);
            setCenterModalDataList({type: 'callback', description: '카테고리를 선택해주세요'});
            setOnCenterModalComplete(() => () => setInitCenterModalState(true));
            return;
        }
        else if(writeValue === null && imageList.length === 0)
        {
            setCenterModalVisible(true);
            setCenterModalDataList({type: 'callback', description: '게시글을 입력해주세요'});
            setOnCenterModalComplete(() => () => setInitCenterModalState(true));
            return;
        }

        if(isSubmitting === false)
        {
            setIsSubmitting(true);
            const newImageList = imageList.filter((image) => {
                return image['type'] === 'newImage';
            })

            if(newImageList.length !== 0)
            {
                onSubmitFormData();
            }
            else
            {
                const fileNameList = [];
                for(let i = 0; i < imageList.length; ++i)
                {
                    fileNameList.push(imageList[i]['data']);
                }
                const body = {
                    category_no: writeType,
                    content: writeValue,
                    img_attachment: fileNameList
                }
                
                if(type === 'campaign')
                {
                    await server.putRequestData(`campaigns/posts/${postNo}`, JSON.stringify(body), handleUpdatePostCallback);
                }
                else if(type === 'group')
                {
                    await server.putRequestData(`groups/posts/${postNo}`, JSON.stringify(body), handleUpdatePostCallback);
                }
            }
        }
    }

    const handleCancelWrite = () => {
        history.goBack();
    }

    const handleClickCancel = () => {
        setCenterModalVisible(true);
        setCenterModalDataList({type: 'callback', title: '게시물 작성 취소', description: '게시물 작성을 취소하시겠어요?'});
        setOnCenterModalComplete(() => () => handleCancelWrite());
        setOnCenterModalCancel(() => () => setInitCenterModalState(true));
    }

    const initCallback = (res) => {
        try
        {
            if(res['success'] !== 1) 
            {
                return;
            }
            const post = res['data']['posts'][0];
            const copyImageList = [];
            post['img_attachment'] = post['img_attachment'] === null ? [] : post['img_attachment'];
            setWriteType(postType[post['post_type']]);
            setWriteValue(post['content']);
            setCurrImgCapacity(post['img_attachment'] === null ? 0 : post['img_attachment'].length)
            for(let i = 0; i < post['img_attachment'].length; ++i)
            {
                copyImageList.push({type: 'bucketImage', data: post['img_attachment'][i]});
            }
            setImageList([...imageList, ...copyImageList]);
            setIsLoading(false);
        }
        catch(error)
        {
            console.log(error);
        }
    }

    useEffect(() => {
        if(isLoading || isEnd) return;
        setIsLoading(true);
        
        if(type === 'campaign')
        {
            server.getRequestData(url, initCallback)
        }
        else if(type = 'group')
        {
            server.getRequestData(url, initCallback)
        }
    }, [])

    useEffect(() => {
        if(initCenterModalState === true)
        {
            setCenterModalVisible(false);
            setCenterModalDataList(null);
            setOnCenterModalComplete(null);
            setOnCenterModalCancel(null);
            setInitCenterModalState(false);
        }
    }, [initCenterModalState])
    
    return(
        <>
            <CommunityPostEditSection>
                <FixedTopNav>
                    <TitleHeader title={'커뮤니티'} isCloseBtn={true}/>
                    <DummySpacer></DummySpacer>
                </FixedTopNav>
                <BodyWrapper>
                    <CommunityWriteForm 
                        writeVisible={true} 
                        imageList={imageList}
                        writeType={writeType}
                        writeValue={writeValue}
                        currImgCapacity={currImgCapacity}
                        onChangeWriteType={handleChangeWriteType}
                        onChangeWriteValue={handleChangeWriteValue}
                        onChangeImageList={handleChangeImageList}
                        onCancelWrite={handleClickCancel}
                        onSubmit={handleSubmit}
                        onClickDeleteImage={handleClickDeleteImage  }
                        fileInputRef={fileInputRef}
                        type={type}
                    />
                </BodyWrapper>
            </CommunityPostEditSection>
            <CenterModal 
              modalVisible={centerModalVisible} 
              dataList={centerModalDataList} 
              onComplete={onCenterModalComplete} 
              onCancel={onCenterModalCancel}
            />
        </>
    );
}

const CommunityPostEditSection = styled.div`
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-flow: column;
`;

const FixedTopNav = styled.div`
  flex: 0 1 auto;
`;

const DummySpacer = styled.div`
  height: calc(100vw*(51/375));
`;

const BodyWrapper = styled.div`
  flex: 1 1 auto;
  overflow: hidden;
  height: 100%;
  padding: calc(100vw * (19 / 375)) calc(100vw * (16 / 375)) 0 calc(100vw * (17 / 375));
  background: #f7f7f7;
`